export const CLASSES_STORE_NAME = 'ClassesStore';

export enum API_VARIABLES {
  CLASS_ID = '{classId}',
  DEPARTMENT_ID = '{departmentId}',
  ORGANIZATION_ID = '{organizationId}',
  COURSE_ID = '{courseId}',
  PERSON_ID = '{personId}',
  PAGE = '{page}',
  PAGE_SIZE = '{pageSize}',
  SORT_BY = '{sortBy}',
  TYPES_CONTENT = '{typesContent}',
  QUICK_CONTENT_ID = '{quickContentId}',
  TEMPLATE_ID = '{templateId}'
}

export enum PREFERENCES_VALUES {
  EXTEND_DUE_DATE = 'EXTENDED_DUE_DATE_FOR_TASKS',
  TIME_FRAME_CONTENT_ENABLED = 'TIME_FRAME_CONTENT_ENABLED_BY_TEACHER',
  GRADING_METHOD = 'GRADING_METHOD'
}

export const ACTIONS = {
  GET_ALL_CLASSES_A:'getAllClassesA',
  CREATE_CLASS_A: 'createClassA',
  DELETE_CLASS_A: 'deleteClassA',
  INACTIVATE_CLASS_A: 'inactivateClassA',
  UPDATE_CLASS_A: 'updateClassA',
  GET_CLASSES_BY_DEPARTMENT_A:'getClassesByDepartmentA',
  GET_CLASS_STUDENTS_A:'getStudentsByClassA',
  GET_ORGANIZATION_STUDENTS_A: 'getStudentsByOrganizationA',
  GET_CLASS_TEACHERS_A:'getTeachersByClassA',
  GET_ORGANIZATION_TEACHERS_A: 'getTeachersByOrganizationA',
  GET_CLASS_COURSES_A: 'getCoursesByClassA',
  GET_ORGANIZATION_COURSES_A: 'getCoursesByOrganizationA',
  ADD_STUDENT_TO_CLASS_A: 'addStudentToClassA',
  REMOVE_STUDENT_FROM_CLASS_A: 'removeStudentFromClassA',
  ADD_TEACHER_TO_CLASS_A: 'addTeacherToClassA',
  REMOVE_TEACHER_FROM_CLASS_A: 'removeTeacherFromClassA',
  ADD_COURSE_TO_CLASS_A: 'addCourseToClassA',
  REMOVE_COURSE_FROM_CLASS_A: 'removeCourseFromClassA',
  UPDATE_MAIN_TEACHER_A: 'updateMainTeacherA',
  SEARCH_USERS_ORGANIZATION_A: 'searchUsersOrganizationA',
  SEARCH_COURSES_ORGANIZATION_A: 'searchCoursesByOrganizationA',
  UPDATE_COURSE_CONFIG_A: 'updateCourseConfigA',
  REMOVE_COURSE_TEACHER_FROM_CLASS_A: 'removeCourseTeacherFromClassA',
  UPDATE_COURSE_OWNER_A: 'updateCourseOwnerA',
  SHARE_COURSE_A: 'shareCourseA',
  UNSHARE_COURSE_A: 'unshareCourseA',
  BLOCK_COURSE_A: 'blockCourseA',
  UNBLOCK_COURSE_A: 'unblockCourseA',
  GET_SHARED_TEACHERS_A: 'getSharedTeachersA',
  GET_ORGANIZATION_CLASS_STUDENTS_A: 'getStudentsByOrganizationAndClassA',
  GET_CLASS_BY_ORG_A: 'getClassesByOrganizationA',
  CAN_SUBSTITUTE_TEACHER_EDIT_CLASS_A: 'canSubstituteTeacherEditClassA',
  CREATE_QUICK_CONTENT_A: 'createQuickContentA',
  UPDATE_QUICK_CONTENT_A: 'updateQuickContentA',
  REMOVE_QUICK_CONTENT_A: 'removeQuickContentA',
  CREATE_SUBJECT_FOR_BUILDER_A: 'createSubjectForBuilderA'
}

export const MUTATIONS = {
  SET_ALL_CLASSES_M:'setAllClassesM',
  SET_CLASSES_M: 'setPagedClassesM',
  CLEAR_CLASSES_M: 'clearPagedClassesM',
  SET_CLASS_STUDENTS_M: 'setClassStudentsM',
  SET_ORGANIZATION_STUDENTS_M: 'setPagedOrganizationStudentsM',
  SET_CLASS_TEACHERS_M: 'setClassTeachersM',
  SET_ORGANIZATION_TEACHERS_M: 'setPagedOrganizationTeachersM',
  SET_CLASS_COURSES_M: 'setClassCoursesM',
  SET_ORGANIZATION_COURSES_M: 'setPagedOrganizationCoursesM',
  CLEAR_COURSES_M: 'clearCoursesM',
  CLEAR_STUDENTS_M: 'clearStudentsM',
  CLEAR_TEACHERS_M: 'clearTeachersM',
  ADD_STUDENT_TO_CLASS_M: 'addStudentToClassM',
  REMOVE_STUDENT_FROM_CLASS_M: 'removeStudentFromClassM',
  ADD_TEACHER_TO_CLASS_M: 'addTeacherToClassM',
  REMOVE_TEACHER_FROM_CLASS_M: 'removeTeacherFromClassM',
  ADD_COURSE_TO_CLASS_M: 'addCourseToClassM',
  REMOVE_COURSE_FROM_CLASS_M: 'removeCourseFromClassM',
  UPDATE_MAIN_TEACHER_M: 'updateMainTeacherM',
  UPDATE_COURSE_CONFIG_M: 'updateCourseConfigM',
  UPDATE_COURSE_OWNER_M: 'updateCourseOwnerM',
  SHARE_COURSE_M: 'shareCourseM',
  UNSHARE_COURSE_M: 'unshareCourseM',
  BLOCK_COURSE_M: 'blockCourseM',
  UNBLOCK_COURSE_M: 'unblockCourseM',
  GET_SHARED_TEACHERS_M: 'getSharedTeachersM',
  RESET_SHARED_TEACHERS_M: 'resetSharedTeachersM',
  CAN_SUBSTITUTE_TEACHER_EDIT_CLASS_M: 'canSubstituteTeacherEditClassM',
  UPDATE_COURSE_IN_CLASS_M: 'updateCourseInClassM',
  UPDATE_CLASS_NAME_M: 'updateClassNameM',
  SET_CLASS_SCHEDULE_M: 'setClassScheduleM',
}

export const _CLASSES_STORE = {
  NAME: CLASSES_STORE_NAME,
  MUTATIONS: {
    SET_ALL_CLASSES_M:`${CLASSES_STORE_NAME}/${MUTATIONS.SET_ALL_CLASSES_M}`,
    SET_CLASSES_M:`${CLASSES_STORE_NAME}/${MUTATIONS.SET_CLASSES_M}`,
    CLEAR_CLASSES_M:`${CLASSES_STORE_NAME}/${MUTATIONS.CLEAR_CLASSES_M}`,
    SET_CLASS_STUDENTS_M:`${CLASSES_STORE_NAME}/${MUTATIONS.SET_CLASS_STUDENTS_M}`,
    SET_ORGANIZATION_STUDENTS_M:`${CLASSES_STORE_NAME}/${MUTATIONS.SET_ORGANIZATION_STUDENTS_M}`,
    SET_CLASS_TEACHERS_M:`${CLASSES_STORE_NAME}/${MUTATIONS.SET_CLASS_TEACHERS_M}`,
    SET_ORGANIZATION_TEACHERS_M:`${CLASSES_STORE_NAME}/${MUTATIONS.SET_ORGANIZATION_TEACHERS_M}`,
    SET_CLASS_COURSES_M:`${CLASSES_STORE_NAME}/${MUTATIONS.SET_CLASS_COURSES_M}`,
    SET_ORGANIZATION_COURSES_M:`${CLASSES_STORE_NAME}/${MUTATIONS.SET_ORGANIZATION_COURSES_M}`,
    CLEAR_STUDENTS_M:`${CLASSES_STORE_NAME}/${MUTATIONS.CLEAR_STUDENTS_M}`,
    CLEAR_TEACHERS_M:`${CLASSES_STORE_NAME}/${MUTATIONS.CLEAR_TEACHERS_M}`,
    CLEAR_COURSES_M:`${CLASSES_STORE_NAME}/${MUTATIONS.CLEAR_COURSES_M}`,
    ADD_STUDENT_TO_CLASS_M:`${CLASSES_STORE_NAME}/${MUTATIONS.ADD_STUDENT_TO_CLASS_M}`,
    REMOVE_STUDENT_FROM_CLASS_M:`${CLASSES_STORE_NAME}/${MUTATIONS.REMOVE_STUDENT_FROM_CLASS_M}`,
    ADD_COURSE_TO_CLASS_M:`${CLASSES_STORE_NAME}/${MUTATIONS.ADD_COURSE_TO_CLASS_M}`,
    REMOVE_COURSE_FROM_CLASS_M:`${CLASSES_STORE_NAME}/${MUTATIONS.REMOVE_COURSE_FROM_CLASS_M}`,
    UPDATE_MAIN_TEACHER_M:`${CLASSES_STORE_NAME}/${MUTATIONS.UPDATE_MAIN_TEACHER_M}`,
    UPDATE_COURSE_CONFIG_M:`${CLASSES_STORE_NAME}/${MUTATIONS.UPDATE_COURSE_CONFIG_M}`,
    UPDATE_COURSE_OWNER_M: `${CLASSES_STORE_NAME}/${MUTATIONS.UPDATE_COURSE_OWNER_M}`,
    SHARE_COURSE_M:`${CLASSES_STORE_NAME}/${MUTATIONS.SHARE_COURSE_M}`,
    UNSHARE_COURSE_M: `${CLASSES_STORE_NAME}/${MUTATIONS.UNSHARE_COURSE_M}`,
    BLOCK_COURSE_M: `${CLASSES_STORE_NAME}/${MUTATIONS.BLOCK_COURSE_M}`,
    UNBLOCK_COURSE_M: `${CLASSES_STORE_NAME}/${MUTATIONS.UNBLOCK_COURSE_M}`,
    GET_SHARED_TEACHERS_M: `${CLASSES_STORE_NAME}/${MUTATIONS.GET_SHARED_TEACHERS_M}`,
    RESET_SHARED_TEACHERS_M: `${CLASSES_STORE_NAME}/${MUTATIONS.RESET_SHARED_TEACHERS_M}`,
    CAN_SUBSTITUTE_TEACHER_EDIT_CLASS_M: `${CLASSES_STORE_NAME}/${MUTATIONS.CAN_SUBSTITUTE_TEACHER_EDIT_CLASS_M}`,
    UPDATE_COURSE_IN_CLASS_M: `${CLASSES_STORE_NAME}/${MUTATIONS.UPDATE_COURSE_IN_CLASS_M}`,
    UPDATE_CLASS_NAME_M: `${CLASSES_STORE_NAME}/${MUTATIONS.UPDATE_CLASS_NAME_M}`,
    SET_CLASS_SCHEDULE_M: `${CLASSES_STORE_NAME}/${MUTATIONS.SET_CLASS_SCHEDULE_M}`,
  },
  ACTIONS: {
    GET_ALL_CLASSES_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_ALL_CLASSES_A}`,
    CREATE_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.CREATE_CLASS_A}`,
    DELETE_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.DELETE_CLASS_A}`,
    INACTIVATE_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.INACTIVATE_CLASS_A}`,
    UPDATE_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.UPDATE_CLASS_A}`,
    GET_CLASSES_BY_DEPARTMENT_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_CLASSES_BY_DEPARTMENT_A}`,
    GET_CLASS_STUDENTS_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_CLASS_STUDENTS_A}`,
    GET_ORGANIZATION_STUDENTS_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_ORGANIZATION_STUDENTS_A}`,
    GET_CLASS_TEACHERS_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_CLASS_TEACHERS_A}`,
    GET_ORGANIZATION_TEACHERS_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_ORGANIZATION_TEACHERS_A}`,
    GET_CLASS_COURSES_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_CLASS_COURSES_A}`,
    GET_ORGANIZATION_COURSES_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_ORGANIZATION_COURSES_A}`,
    ADD_STUDENT_TO_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.ADD_STUDENT_TO_CLASS_A}`,
    REMOVE_STUDENT_FROM_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.REMOVE_STUDENT_FROM_CLASS_A}`,
    ADD_TEACHER_TO_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.ADD_TEACHER_TO_CLASS_A}`,
    REMOVE_TEACHER_FROM_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.REMOVE_TEACHER_FROM_CLASS_A}`,
    ADD_COURSE_TO_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.ADD_COURSE_TO_CLASS_A}`,
    REMOVE_COURSE_FROM_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.REMOVE_COURSE_FROM_CLASS_A}`,
    UPDATE_MAIN_TEACHER_A:`${CLASSES_STORE_NAME}/${ACTIONS.UPDATE_MAIN_TEACHER_A}`,
    SEARCH_USERS_ORGANIZATION_A:`${CLASSES_STORE_NAME}/${ACTIONS.SEARCH_USERS_ORGANIZATION_A}`,
    SEARCH_COURSES_ORGANIZATION_A:`${CLASSES_STORE_NAME}/${ACTIONS.SEARCH_COURSES_ORGANIZATION_A}`,
    UPDATE_COURSE_CONFIG_A:`${CLASSES_STORE_NAME}/${ACTIONS.UPDATE_COURSE_CONFIG_A}`,
    REMOVE_COURSE_TEACHER_FROM_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.REMOVE_COURSE_TEACHER_FROM_CLASS_A}`,
    UPDATE_COURSE_OWNER_A: `${CLASSES_STORE_NAME}/${ACTIONS.UPDATE_COURSE_OWNER_A}`,
    SHARE_COURSE_A: `${CLASSES_STORE_NAME}/${ACTIONS.SHARE_COURSE_A}`,
    UNSHARE_COURSE_A: `${CLASSES_STORE_NAME}/${ACTIONS.UNSHARE_COURSE_A}`,
    BLOCK_COURSE_A: `${CLASSES_STORE_NAME}/${ACTIONS.BLOCK_COURSE_A}`,
    UNBLOCK_COURSE_A: `${CLASSES_STORE_NAME}/${ACTIONS.UNBLOCK_COURSE_A}`,
    GET_SHARED_TEACHERS_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_SHARED_TEACHERS_A}`,
    GET_ORGANIZATION_CLASS_STUDENTS_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_ORGANIZATION_CLASS_STUDENTS_A}`,
    GET_CLASS_BY_ORG_A: `${CLASSES_STORE_NAME}/${ACTIONS.GET_CLASS_BY_ORG_A}`,
    CAN_SUBSTITUTE_TEACHER_EDIT_CLASS_A: `${CLASSES_STORE_NAME}/${ACTIONS.CAN_SUBSTITUTE_TEACHER_EDIT_CLASS_A}`,
    CREATE_QUICK_CONTENT_A: `${CLASSES_STORE_NAME}/${ACTIONS.CREATE_QUICK_CONTENT_A}`,
    UPDATE_QUICK_CONTENT_A: `${CLASSES_STORE_NAME}/${ACTIONS.UPDATE_QUICK_CONTENT_A}`,
    REMOVE_QUICK_CONTENT_A: `${CLASSES_STORE_NAME}/${ACTIONS.REMOVE_QUICK_CONTENT_A}`,
    CREATE_SUBJECT_FOR_BUILDER_A: `${CLASSES_STORE_NAME}/${ACTIONS.CREATE_SUBJECT_FOR_BUILDER_A}`,
  }
}

export const CLASSES_API = {
  CREATE_CLASS: 'classes/class',
  GET_ALL_CLASSES: 'classes/classes/myClasses',
  // TODO: Check before move to test
  GET_INSTITUTION_DEPARTMENT: 'department?orgId={organizationId}',
  // GET_INSTITUTION_DEPARTMENT: 'department?schoolId={organizationId}',
  // TODO: Check before move to test
  // GET_CLASSES_BY_DEPARTMENT: 'classes/classes?departmentId={departmentId}&page={page}&pageSize={pageSize}',
  GET_CLASSES_BY_DEPARTMENT: 'classes/classes?departmentId={departmentId}&page={page}&pageSize={pageSize}&sortBy={sortBy}',
  GET_INACTIVE_CLASSES_BY_DEPARTMENT: 'classes/inactive?departmentId={departmentId}&page={page}&pageSize={pageSize}&sortBy={sortBy}',
  GET_CLASS_STUDENTS: 'classes/class/{classId}/students?page=0&pageSize=-1',
  GET_TEACHING_CLASSES_AND_SHARED_CONTENTS: 'classes/teachingClassesAndSharedContents?organizationId={organizationId}&personId={personId}',
  GET_ORGANIZATION_STUDENTS: 'organization/{organizationId}/users/STUDENT',
  GET_CLASS_TEACHERS: 'classes/class/{classId}/staff?excludeMe=false',
  GET_ORGANIZATION_TEACHERS: 'organization/{organizationId}/users/SDA,SA,TEACHER',
  GET_CLASS_COURSES: 'classes/{classId}/courses?page=0&pageSize=-1&typesContent={typesContent}',
  GET_ORGANIZATION_COURSES: 'content/organization/{organizationId}',
  ADD_REMOVE_STUDENT_TO_CLASS: 'classes/class/{classId}/students',
  ADD_REMOVE_TEACHER_TO_CLASS: 'classes/class/{classId}/coinstructors',
  ADD_REMOVE_COURSE_TO_CLASS: 'classes/class/{classId}/courses',
  GET_CLASS: 'classes/class/{classId}',
  UPDATE_DELETE_CLASS: 'classes/class/{classId}',
  INACTIVATE_CLASS: 'classes/class/{classId}/inactivate',
  UPDATE_TEACHER_CLASS: 'classes/class/{classId}/teacher/{personId}',
  SEARCH_USERS_ORGANIZATION: 'organization/internal/organization/{organizationId}/users/search',
  GET_UPDATE_COURSE_CONFIG: 'classes/class/{classId}/course/{courseId}',
  REMOVE_COURSE_TEACHER_FROM_CLASS: 'classes/class/{classId}/courseteacher',
  UPDATE_COURSE_OWNER: 'content/{courseId}/owner/{personId}',
  SHARE_UNSHARE_COURSE: 'content/{courseId}/share/{personId}',
  BLOCK_UNBLOCK_COURSE: 'content/{courseId}/lock',
  GET_SHARED_TEACHERS: 'content/{courseId}/share',
  GET_ORGANIZATION_CLASS_STUDENTS: 'classes/students/{organizationId}',
  GET_CLASSES_BY_ORG: 'classes/organization/{organizationId}',
  CAN_SUBSTITUTE_TEACHER_EDIT_CLASS: 'classes/{classId}/substituteTeacherPrivs',
  ALLOW_TEACHERS_TO_EDIT_CLASS: 'classes/{classId}/allowTeachersToModifySchedule',
  /* Quick Subjects */
  GET_COURSE_TEMPLATE_BY_CLASS: 'course/template/{templateId}/class/{classId}',
  CREATE_QUICK_CONTENT: 'content/upload/courseTemplate/{templateId}/class/{classId}/quickContent',
  REMOVE_QUICK_CONTENT: 'content/quickContent/{quickContentId}',
  GET_QUICK_CONTENT: 'content/quickContent/{quickContentId}',
  UPDATE_QUICK_CONTENT: 'content/upload/courseTemplate/{templateId}/quickContent/{quickContentId}',
  /* Subject For Builder */
  CREATE_SUBJECT_FOR_BUILDER: 'course/builder/{templateId}/createSubjectForBuilder'
}

export const CONTENT_TYPE = {
  SUBJECT: 'CS',
  QUICK_SUBJECT: 'CSQ',
  TEMPLATE: 'CT',
}
